<template>
    <div class="uik-widget-title__wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikWidgetHeader"
}
</script>

<style lang="scss">
.uik-widget-title__wrapper {
  padding: 18px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:last-child) {
    border-bottom: $borderDefault;
  }
  h3 {
    /* Title: */
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.75rem;
    +* {
      margin-top: 0;
    }
  }
  &.uik-widget-title__noDivider {
    padding-bottom: 5px;
    border-bottom: none;
  }
}
</style>
